import React from 'react';
import { Tabs } from 'antd';
import { UnorderedListOutlined, SettingOutlined } from '@ant-design/icons';
import OutboundTasks from './OutboundTasks';
import OutboundWorkflows from './OutboundWorkflows';

const { TabPane } = Tabs;

const OutboundMain: React.FC = () => {
	return (
		<div className="min-h-screen bg-gray-50">
			<Tabs
				defaultActiveKey="tasks"
				className="h-full"
				tabBarStyle={{
					background: 'white',
					margin: 0,
					padding: '0 24px',
					borderBottom: '1px solid #f0f0f0',
				}}
				size="large"
			>
				<TabPane
					tab={
						<span className="flex items-center gap-2">
							<UnorderedListOutlined />
							Outbound Tasks
						</span>
					}
					key="tasks"
				>
					<OutboundTasks />
				</TabPane>

				<TabPane
					tab={
						<span className="flex items-center gap-2">
							<SettingOutlined />
							Outbound Workflows
						</span>
					}
					key="workflows"
				>
					<OutboundWorkflows />
				</TabPane>
			</Tabs>
		</div>
	);
};

export default OutboundMain;
